/**
 * 剐蹭补贴
 */
import { SCRATCHRECORD } from '../types';

export default {
    name: `${SCRATCHRECORD}`,
    path: '/scratchRecord',
    component: () => import(/* webpackChunkName: 'scratchRecord' */ '@/views/scratchRecord/'),
    redirect: { name: `${SCRATCHRECORD}Index` },
    meta: {
        title: '剐蹭补贴',
        savedPosition: { x: 0, y: 0 },
    },
    children: [
        {
            name: `${SCRATCHRECORD}Index`,
            path: 'index',
            component: () => import(/* webpackChunkName: 'scratchRecord' */ '@/views/scratchRecord/home/Home.vue'),
        },

        // 二级页面示例, 没有二级页面就直接删掉
        {
            name: `${SCRATCHRECORD}Detail`,
            path: 'detail/:id',
            component: () => import(/* webpackChunkName: 'scratchRecord' */ '@/views/scratchRecord/detail/Detail.vue'),
        },
    ],
};
